import { render } from "./TermsForm.vue?vue&type=template&id=202a7835"
import script from "./TermsForm.vue?vue&type=script&lang=js"
export * from "./TermsForm.vue?vue&type=script&lang=js"

import "./TermsForm.vue?vue&type=style&index=0&id=202a7835&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__